import { render, staticRenderFns } from "./ModalBettingList.vue?vue&type=template&id=a168bf90&"
import script from "./ModalBettingList.vue?vue&type=script&lang=js&"
export * from "./ModalBettingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports